import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { makeQuickFetchRequest } from 'marketing-platform-lib/utils/quickFetch';
export const FETCH_CRM_OBJECT_TYPE_DEFINITION_FIELD_NAME = 'fetchCrmObjectTypeDefinition';
export const FETCH_CRM_OBJECT_TYPE_DEFINITION_QUERY = registerQuery({
  fieldName: FETCH_CRM_OBJECT_TYPE_DEFINITION_FIELD_NAME,
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    const quickFetchName = `fetch-crm-object-type-definition-${objectTypeId}`;
    const typeDefinitionRequest = () => http.get(`api/inbounddb-meta/v1/object-types/${objectTypeId}`);
    return makeQuickFetchRequest({
      makeRequestFn: typeDefinitionRequest,
      requestName: quickFetchName
    });
  }
});
export default function useFetchCrmObjectTypeDefinition(objectTypeId) {
  const _useQuery = useQuery(FETCH_CRM_OBJECT_TYPE_DEFINITION_QUERY, {
      variables: {
        objectTypeId
      },
      skip: !objectTypeId
    }),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return useMemo(() => Object.assign({
    data: data && FETCH_CRM_OBJECT_TYPE_DEFINITION_FIELD_NAME in data ? data[FETCH_CRM_OBJECT_TYPE_DEFINITION_FIELD_NAME] : undefined
  }, rest), [data, rest]);
}